import * as React from 'react';

import InfluencerEntity from 'modules/influencers/components/influencer-entity/InfluencerEntity';

import type { InfluencerProfile, InfluencerTile, SubcampaignInfluencerProfile } from 'types';

type Props = {
  influencerProfile: InfluencerProfile | InfluencerTile | SubcampaignInfluencerProfile | undefined | null
};

class ModalFrameEntity extends React.PureComponent<Props> {
  render() {
    const { influencerProfile } = this.props;

    if (!influencerProfile) {
      return null;
    }

    return (
      <div className="modal-frame-entity">
        <InfluencerEntity influencerProfile={influencerProfile} />
      </div>
    );
  }
}

export default ModalFrameEntity;
